// useBankTransfer.ts
import { useState } from "react";
import type { BankTransferVariant } from "../components/themes";
import { bankTransferVariants } from "../components/themes";
import type { DetailsFormValues } from "../components/DetailsForm/DetailsForm";

type UseBankTransferArgs = {
  bankVariant?: BankTransferVariant;
};

export const useBankTransfer = ({ bankVariant = "default" }: UseBankTransferArgs) => {
  const expandable = bankTransferVariants[bankVariant]?.expandable ?? false;

  const [expanded, setExpanded] = useState(false);

  const [details, setDetails] = useState<DetailsFormValues>({
    accountHolderName: "",
    routingNumber: "",
    accountNumber: "",
    address: "",
  });

  const handleToggle = () => {
    if (!expandable) return;
    setExpanded((v) => !v);
  };

  return {
    expandable,
    expanded,
    setExpanded,

    details,
    setDetails,

    handleToggle,
  };
};
